<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button type="button" class="btn btn-secondary btn-fg custom-shadow-btn" @click="$router.push('/monitorings/create')">
              <i class="fa fa-plus"></i>
              Agregar Informe
            </button>
          </div>
        </div>
        <hr>
        <!--<div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Informes de Seguimientos Activos</h6>
          </div>
        </div>-->
        <div v-if="canIndex()" class="text item">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-2">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <el-select multiple collapse-tags
                  style="width: 100%"
                  class="select-primary select_modules  mb-3"
                  v-model="demands"
                  @change="getDataByDemandDates"
                  filterable placeholder="Proyecto">
                  <el-option v-for="option in $store.state.auth.user.demands"
                              class="select-primary"
                              :value="option.id"
                              :label="option.code"
                              :key="option.name">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-date-picker
                  class="picker-filter"
                  style="width: 100%"
                  :clearable="false"
                  v-model="rangeDate"
                  type="daterange"
                  @change="getDataByDemandDates"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  start-placeholder="Fecha Inicial"
                  end-placeholder="Fecha Final"
                  align="center">
                </el-date-picker>
              </div>
              <div class="col-6 col-sm-4 col-md-3" style="width: 100%">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('informes_de_seguimientos', 'Informes de Seguimiento', 'a4', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('informes_de_seguimientos', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('informes_de_seguimientos', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <br class="c-none">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Descargar Anexos'" class="btn-primary btn-simple btn-link"
                     @click="handlePreviewDownload(props.$index, props.row)">
                     <i class="fa fa-download"></i>
                  </a>
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i>
                  </a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)">
                     <i class="fa fa-edit"></i>
                  </a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i>
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="text-right">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('informes_de_seguimientos', 'Informes de Seguimiento', 'a4', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('informes_de_Seguimiento', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-left">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('informes_de_seguimientos', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p v-if="isShow">A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <p v-if="!isShow">Por favor selecciona uno o todos los archivos a descargar.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                <tr class="shadow-sm" v-if="isShow">
                  <td scope="row">
                    <h6><b>Nombre:</b></h6>
                    {{rowData.name}}
                  </td>
                </tr>
                <tr class="shadow-sm" v-if="isShow">
                  <td scope="row">
                    <h6><b>Descripción:</b></h6>
                    {{rowData.description}}
                  </td>
                </tr>
                <tr class="shadow-sm" v-if="isShow">
                  <td scope="row">
                    <h6><b>Fecha:</b></h6>
                    {{rowData.date}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table"><b>Anexos:</b></h6>
                    <el-tag
                      effect="dark"
                      :closable="true"
                      :close-transition="false"
                      type="warning"
                      v-if="rowData.annexes.length > 1"
                      class="pointer"
                      @click="handleDownload('all', rowData)">
                        <i class="fa fa-copy"></i>Descargar Todos
                    </el-tag>
                    <span v-for="(annexe, index) in rowData.annexes" :key="index">
                      <el-tag
                        effect="dark"
                        :closable="true"
                        :close-transition="false"
                        @click="handleDownload(index, rowData)"
                        class="pointer">{{annexe}}</el-tag>
                      <br v-if="index %5 == 0 && index != 0"/>
                    </span>
                    <el-tag v-if="rowData.annexes.length == 0">No tiene anexos adjuntos</el-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
          </div>
      </div>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import swal from 'sweetalert2'
  import table from './monitoringTable'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    data () {
      return {
        monitoringForm: {},
        demands: [],
        monitorings: null,
        tableColumns: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)]
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)

        if (!this.rowData.annexes)
          this.rowData.annexes = []

        this.title = 'Informe: '+this.rowData.name
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.openModal('read')
      },
      handleEdit (index, row) {
        this.monitoringForm = Object.assign({}, row)
        localStorage.setItem( 'monitoringEdit', JSON.stringify(this.monitoringForm) )
        this.$router.push({ name: 'Editar Informe de Seguimiento' });
      },
      handleDelete (index, row) {
        this.monitoringForm = Object.assign({}, row)
        showSwalAlert('Informe de Seguimiento', 'delete', true, null, 'Informe: ' + row.name).then((result) => {
          if (result.value) this.deleteMonitoring()
        })
      },
      deleteMonitoring() {
        this.$emit('cotentLoading', true)
        this.monitoringForm.route = 'monitorings'
        this.destroyMaster(this.monitoringForm).then((response) => {
          this.modifyTable(2, this.monitoringForm.id, response)
        })
      },

      handleFilterRange() {
        this.getDataByDates()
      },

      handlePreviewDownload (index, row) {
        this.handleView(index, row)
        this.isShow = false
      },

      handleDownload (index, row) {
        this.closeModal('read')
        showSwalAlert(
          'Espere mientras el o los archivos se descargan.',
            null, false, null, null, null, swal
        )

        return axios({
            url: '/auth/monitorings/download/' + row.id + '/' + index,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', index == 'all' ? 'anexos.zip' : row.annexes[index]);
            document.body.appendChild(link);
            link.click();
            swal.close()
        }).catch((error) => this.showMessageErrors(error))
      },

      getDataByDemandDates() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='monitorings/demands_index'
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        if (this.demands.length >= 1) data.demands = this.demands
        else data.demands = this.$store.state.auth.user.demands.map(demand => demand.id)

        this.saveMaster(data).then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['name', 'description', 'date'])
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
    },
    created(){
      if(this.canIndex()) {
        this.getDataByDemandDates()
      }
    }
  }
</script>

